var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleGs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.205,
    height: 37,
    viewBox: "0 0 37.205 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "google_disabled_state_",
    "data-name": "google (disabled state)",
    d: "M16535.684,22554.357l6.105-3.516a10.9,10.9,0,0,0,14.945,4l0,0,0,0a11.06,11.06,0,0,0,4.752-5.562h-8.268a1.169,1.169,0,0,1-1.168-1.172v-4.7a1.167,1.167,0,0,1,1.168-1.172h14.684a1.183,1.183,0,0,1,1.156.963,12.184,12.184,0,0,1,.2,2.3,17.659,17.659,0,0,1-9,15.432l0,.006v.006l-.006,0v0l-.018.012a17.985,17.985,0,0,1-24.562-6.609Zm0-17.98a18.148,18.148,0,0,1,2.027-2.844,17.909,17.909,0,0,1,13.559-6.164v0a17.937,17.937,0,0,1,11.785,4.416c.023.018.045.041.063.057a1.182,1.182,0,0,1,.006,1.672l-3.324,3.324a1.176,1.176,0,0,1-1.58.074,10.94,10.94,0,0,0-16.43,13.926l-6.105,3.516A17.9,17.9,0,0,1,16535.684,22536.377Z",
    transform: "translate(-16532.563 -22526.867)",
    fill: "#bfbdc5",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGs);
export default __webpack_public_path__ + "static/media/google-gs.dff2e405fc3489407b12ad6f74d29d10.svg";
export { ForwardRef as ReactComponent };